/**
 * AdminJournal.tsx - обратная совместимость
 *
 * Компонент перенесён в папку OnlineJournal/ с полным рефакторингом.
 * Этот файл сохранён как ре-экспорт, чтобы не ломать существующие импорты
 * в AdminPanel.tsx и других местах.
 *
 * @see ./OnlineJournal/OnlineJournal.tsx
 */
export { default } from './OnlineJournal';
